/* global axios */
import ApiClient from './ApiClient';

class SalesTransactionReceiptAnalysisAPI extends ApiClient {
  constructor() {
    super('sales_transactions', { accountScoped: true });
  }

  path(transactionId, suffix = '') {
    return `${this.url}/${transactionId}/receipt_analysis${suffix}`;
  }

  show(transactionId) {
    return axios.get(this.path(transactionId));
  }

  saveOcr(transactionId, ocr) {
    return axios.post(this.path(transactionId), { ocr, tipo: 'recibo' });
  }

  saveConflict(transactionId, conflict) {
    return axios.post(this.path(transactionId, '/conflicts'), conflict);
  }
}

export default new SalesTransactionReceiptAnalysisAPI();
